import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MomentDateAdapter } from '../../core/CustomDataAdapter/MomentDateAdapter';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
import {default as _rollupMoment} from 'moment';
import { DayMonthHeaderComponent } from './day-month-header/day-month-header.component';
import { ValueAccessorComponent, createCustomInputControlValueAccessor } from '../base/Input.component';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MMM',
  },
  display: {
    dateInput: 'DD/MMM',
    monthYearLabel: 'MMM',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-day-month-picker',
  templateUrl: './day-month-picker.component.html',
  styleUrls: ['./day-month-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },{provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    createCustomInputControlValueAccessor(DayMonthPickerComponent)]
})
export class DayMonthPickerComponent extends ValueAccessorComponent<any> {

  dayMonthHeader = DayMonthHeaderComponent;
  @Input() placeholder: string;

  constructor() {
    super();
    // this.value= moment();
  }

}


